import { Injectable } from '@angular/core';

import { IntegrationsClientHttpBase } from './http-base';

@Injectable({ providedIn: 'root' })
export class IntegrationsApiService extends IntegrationsClientHttpBase {
  public context: string;
  public get baseUrl(): string {
    if (this.context) {
      return `${this.config.integrationsUrl}/api/${this.context.replace(/_/g, '-')}/c/${
        this.integrationsCredentials.companyId
      }`;
    } else {
      return `${this.config.integrationsUrl}/api/c/${this.integrationsCredentials.companyId}`;
    }
  }
}
